import { Search } from "lucide-react"
import { Button, Kbd } from "@/components/ui/primitives"
import { useTranslation } from "@/hooks/use-translation"
import { useUiStore } from "@/stores/ui-store"

/** Compact Search ⌘K control for fullscreen workspace toolbars. */
export function WorkspaceToolbarSearch() {
  const { t } = useTranslation(["layout"])
  const toggleCommand = useUiStore((s) => s.toggleCommand)

  return (
    <Button
      variant="ghost"
      size="sm"
      type="button"
      className="h-7 px-2.5 text-[11px] text-ui-text-secondary"
      onClick={toggleCommand}
    >
      <Search className="mr-1 h-3.5 w-3.5" />
      {t("shell.header.search")}
      <Kbd className="ml-2 px-1.5 text-[10px]">⌘K</Kbd>
    </Button>
  )
}
